export default "__VITE_ASSET__c71ec62e__"